import { isNotDefined } from '@sgme/fp';
import { FormattedNumber } from 'react-intl';

import { useTargetAccumulatorTileId } from '@/App/tiles/TargetAccumulator/TargetAccumulatorContext.tsx';
import { useAppSelector } from '@/store/hooks.ts';
import { selectTargetAccumulatorTotalLeverage } from '@/store/targetAccumulator/selectors.ts';

const TotalLeverage = () => {
  const tileId = useTargetAccumulatorTileId();

  const totalLeverage = useAppSelector((state) => selectTargetAccumulatorTotalLeverage(state, tileId));
  if (isNotDefined(totalLeverage)) {
    return null;
  }

  return (
    <span className="form-control-plaintext p-0 text-end fs-12" data-e2e="total-leverage">
      <FormattedNumber value={totalLeverage} />
    </span>
  );
};

export default TotalLeverage;
